import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import { companyService, vacancyService } from '../services/api';
import './CompanyVacancies.css';

function CompanyVacancies() {
  const { id } = useParams();
  const [company, setCompany] = useState(null);
  const [vacancies, setVacancies] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadCompanyVacancies();
  }, [id]);

  const loadCompanyVacancies = async () => {
    try {
      setLoading(true);
      const [companiesData, vacanciesData] = await Promise.all([
        companyService.getCompanies(),
        vacancyService.getVacanciesByCompany(id)
      ]);
      
      const foundCompany = companiesData.find(c => c.Id === parseInt(id));
      if (foundCompany) {
        setCompany(foundCompany);
      }
      setVacancies(vacanciesData);
    } catch (error) {
      console.error('Error loading company vacancies:', error);
      alert('Error loading company vacancies. Please try again later.');
    } finally {
      setLoading(false);
    }
  };

  const formatDate = (dateString) => {
    if (!dateString) return '';
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', { 
      year: 'numeric', 
      month: 'short', 
      day: 'numeric' 
    });
  };

  if (loading) {
    return (
      <div className="company-vacancies">
        <div className="container" style={{ textAlign: 'center', padding: '3rem' }}>
          <p>Loading vacancies...</p>
        </div>
      </div>
    );
  }

  if (!company) {
    return (
      <div className="company-vacancies">
        <div className="container" style={{ textAlign: 'center', padding: '3rem' }}>
          <p>Company not found.</p>
          <Link to="/companies" className="back-link">← Back to Companies</Link>
        </div>
      </div>
    );
  }

  return (
    <div className="company-vacancies">
      <div className="company-vacancies-header">
        <div className="container">
          <Link to="/companies" className="back-link">← Back to Companies</Link>
          <div className="company-header-content">
            {company.Logo && (
              <div className="company-header-image">
                <img 
                  src={company.Logo.includes('http') ? company.Logo : `http://localhost:59844/${company.Logo}`} 
                  alt={company.Name}
                  style={{ width: '120px', height: '120px', objectFit: 'contain', borderRadius: '15px' }}
                />
              </div>
            )}
            <div className="company-header-info">
              <h1>{company.Name}</h1>
              {company.Code && <p className="company-code">Code: {company.Code}</p>}
            </div>
          </div>
        </div>
      </div>

      <div className="container">
        <div className="vacancies-section">
          <h2>Available Vacancies ({vacancies.length})</h2>
          <p className="section-subtitle">All open positions at {company.Name}</p>
          
          {vacancies.length === 0 ? (
            <div style={{ textAlign: 'center', padding: '3rem', background: 'white', borderRadius: '10px' }}>
              <p>No vacancies available for this company.</p>
            </div>
          ) : (
            <div className="vacancies-grid">
              {vacancies.map(vacancy => (
                <Link 
                  key={vacancy.Id} 
                  to={`/vacancy/${vacancy.Id}?companyId=${company.Id}`}
                  className="vacancy-card-link"
                >
                  <div className="vacancy-card">
                    <div className="vacancy-header">
                      <h3>{vacancy.Title}</h3>
                      {vacancy.LastDate && (
                        <span className="vacancy-date-badge">Due: {formatDate(vacancy.LastDate)}</span>
                      )}
                    </div>
                    <div className="vacancy-details">
                      {vacancy.PlacementDrive?.Title && (
                        <p><strong>Placement Drive:</strong> {vacancy.PlacementDrive.Title}</p>
                      )}
                      {vacancy.Description && (
                        <p className="vacancy-description">
                          {vacancy.Description.length > 150 
                            ? vacancy.Description.substring(0, 150) + '...' 
                            : vacancy.Description}
                        </p>
                      )}
                      {vacancy.Conditions && (
                        <p className="vacancy-conditions">
                          <strong>Conditions:</strong> {
                            vacancy.Conditions.length > 100 
                              ? vacancy.Conditions.substring(0, 100) + '...' 
                              : vacancy.Conditions
                          }
                        </p>
                      )}
                      {vacancy.Date && (
                        <p style={{ color: '#666', fontSize: '0.9rem', marginTop: '0.5rem' }}>
                          📅 Posted: {formatDate(vacancy.Date)}
                        </p>
                      )}
                    </div>
                    <button className="apply-now-btn">View Details & Apply →</button>
                  </div>
                </Link>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default CompanyVacancies;

